import { seatingPreferenceOptions } from '../constants/seatingPreferenceOptions';
export const getOriginDestinationCities = bounds => {
  var _bounds$, _bounds$at, _first$to, _last$from, _first$from$city, _first$from, _last$to$city, _last$to, _first$to$city, _first$to2;
  const first = (_bounds$ = bounds[0]) === null || _bounds$ === void 0 ? void 0 : _bounds$.boundName;
  const last = (_bounds$at = bounds.at(-1)) === null || _bounds$at === void 0 ? void 0 : _bounds$at.boundName;
  const isMultiCity = bounds.length > 1 && (first === null || first === void 0 || (_first$to = first.to) === null || _first$to === void 0 ? void 0 : _first$to.city) !== (last === null || last === void 0 || (_last$from = last.from) === null || _last$from === void 0 ? void 0 : _last$from.city);
  return {
    from: (_first$from$city = first === null || first === void 0 || (_first$from = first.from) === null || _first$from === void 0 ? void 0 : _first$from.city) !== null && _first$from$city !== void 0 ? _first$from$city : '',
    to: isMultiCity ? (_last$to$city = last === null || last === void 0 || (_last$to = last.to) === null || _last$to === void 0 ? void 0 : _last$to.city) !== null && _last$to$city !== void 0 ? _last$to$city : '' : (_first$to$city = first === null || first === void 0 || (_first$to2 = first.to) === null || _first$to2 === void 0 ? void 0 : _first$to2.city) !== null && _first$to$city !== void 0 ? _first$to$city : ''
  };
};
export const isSeatPreferenceSegment = segment => (segment === null || segment === void 0 ? void 0 : segment.__typename) === seatingPreferenceOptions.SELL_SEATING_BESIDE || (segment === null || segment === void 0 ? void 0 : segment.__typename) === seatingPreferenceOptions.SELL_SEATING_PREFERENCE;
export const flatBounds = (bounds = []) => bounds.flatMap(segments => segments.sellSeatMapSegments.map(segment => {
  var _segment$travelerIds;
  return {
    ...segment,
    boundIndex: segments.boundIndex,
    boundName: segments.boundName,
    boundSegmentId: [segments.boundIndex, segment.boundSegmentIndex],
    isAvailable: Boolean(segment.mainDeck || segment.lowerDeck || segment.upperDeck || isSeatPreferenceSegment(segment)),
    travelerIds: (_segment$travelerIds = segment.travelerIds) !== null && _segment$travelerIds !== void 0 ? _segment$travelerIds : []
  };
}));
export const getSegment = (segments = [], activeSegment) => {
  const hasSegments = segments.some(({
    segmentIndex
  }) => Number.isInteger(segmentIndex));
  if (!hasSegments) {
    return null;
  }
  return segments.find(({
    boundSegmentIndex
  }) => boundSegmentIndex === activeSegment);
};
export const getNextSegment = (segments, activeSegment = null) => {
  var _segments$find;
  if (!Array.isArray(segments) || segments.length === 0) {
    return null;
  }
  const activeIndex = segments.findIndex(segment => typeof segment.boundSegmentIndex === 'string' && segment.boundSegmentIndex === activeSegment);
  return (_segments$find = segments.find((_, index) => index > activeIndex)) !== null && _segments$find !== void 0 ? _segments$find : null;
};
export const getSegmentIndex = (segments, boundSegmentIndex) => segments.findIndex(b => b.boundSegmentIndex === boundSegmentIndex);
export const getNextAvailableSegment = (segments = [], activeSegmentIndex) => {
  const activeIndex = getSegmentIndex(segments, activeSegmentIndex);
  return segments[activeIndex + 1];
};
export const getPreviousAvailableSegment = (segments = [], activeSegmentIndex) => {
  const activeIndex = getSegmentIndex(segments, activeSegmentIndex);
  return segments[activeIndex - 1];
};
export const isFirstAvailableSegment = (segments, boundSegmentIndex) => {
  var _segments$;
  return ((_segments$ = segments[0]) === null || _segments$ === void 0 ? void 0 : _segments$.boundSegmentIndex) === boundSegmentIndex;
};

// FIXME(IN-113): despite the name, this checks the LITERAL last entry in `segments`, not the last
// `isAvailable` one. If the tail of `flattenedBounds` is unavailable (e.g. a segment with no decks
// and not a seat-preference type), navigation walks through it before useSeatMapNavigation reveals
// the summary. Behaviour is pinned by:
//   - segmentUtils.test.ts → "isLastAvailableSegment › returns true only for the last segment"
//   - useSeatMapNavigation.test.ts → "shows the summary when the active segment is the literal last
//     in flattenedBounds"
// Decide whether to (a) filter `segments` by isAvailable here, or (b) rename to
// `isLastSegment`. Same caveat applies to `isFirstAvailableSegment` above.
export const isLastAvailableSegment = (segments, boundSegmentIndex) => {
  var _segments;
  return ((_segments = segments[segments.length - 1]) === null || _segments === void 0 ? void 0 : _segments.boundSegmentIndex) === boundSegmentIndex;
};
export const getSeatCharacteristics = (segments = [], activeBoundSegmentIndex) => {
  var _segment$bestPriceCha;
  const hasSegments = segments.some(({
    segmentIndex
  }) => Number.isInteger(segmentIndex));
  if (!hasSegments) {
    return [];
  }
  const segment = segments.find(({
    boundSegmentIndex
  }) => boundSegmentIndex === activeBoundSegmentIndex);
  return ((_segment$bestPriceCha = segment === null || segment === void 0 ? void 0 : segment.bestPriceCharacteristics) !== null && _segment$bestPriceCha !== void 0 ? _segment$bestPriceCha : []).filter(c => Boolean(c));
};
//# sourceMappingURL=segmentUtils.js.map